import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss'],
})
export class MenuListComponent extends BaseListCtl {
  resetUnassignlist() {
    this.unassignMenuList = [];
    this.assignMenuList = [];
    this.appRoleform = {};
    this.cdr.detectChanges();
    this.selectRoleId = 0;
    this.selectedRoleName = null;
    this.assignMenuList = null;
    this.nodes = null;
  }
  public forms = [];
  public usecases = [];
  public reportlist: any = [];
  public isProfileTabActive: boolean = false;
  public appRoleList = [];
  public assignMenuList: any = [];
  public unassignMenuList: any = [];
  public selectRoleId: number = 0;
  public selectAppId: number = 0;
  public appId: number = 0;
  public applications: any = {};
  public nodes: any;
  public selectedRoleName: any;
  public parentChildHierarchy: any;
  public menuItemsMenu: any;
  public reportMenu: any;
  public searchMessage: string = '';
  public searchError: boolean = false;
  isChildClicked: boolean = true;
  draggedItem: any = null;
  draggedParent: any = null;
  dragElementId: any;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super('', locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));
    _self.form.searchParams['applicationId'] = Number(
      route.snapshot.paramMap.get('appId'),
    );
    _self.form.data['applicationId'] = Number(
      route.snapshot.paramMap.get('appId'),
    );
    _self.getApplications(Number(route.snapshot.paramMap.get('appId')));
    _self.convertStrToNum(Number(route.snapshot.paramMap.get('appId')));
    _self.getRolesList(Number(route.snapshot.paramMap.get('appId')));
    _self.getApiList(Number(route.snapshot.paramMap.get('appId')));
    locator.config
      .getProperty('endpoint.application.menus')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
  }

  /**
   * Get applications Details
   */
  public async getApplications(id: any) {
    let _self = this;
    // get applications
    let url = this.locator.getEndpoint('endpoint.application') + '/get/' + id;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        console.error('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  /**
   * get of usecase form
   */
  async getFormList(userstoryId: any) {
    let _self = this;
    let searchParams = {
      userstoryId: Number(userstoryId),
    };
    this.getData(
      'endpoint.ui.forms',
      '/search',
      searchParams,
      function (data: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.forms = data;
      },
    );
  }

  /**
   *
   * @param endpoint
   * @param uri
   * @param searchParams
   * @param callback
   */
  async getData(
    endpoint: string,
    uri: string,
    searchParams: any,
    callback: any,
  ) {
    this.locator.config.getProperty(endpoint).then((property: string) => {
      let url = property + uri;
      this.locator.http.post(
        url,
        searchParams,
        function (res: any, error: boolean) {
          callback(res.result.data, error, res);
        },
      );
    });
  }

  /**
   * Convert the value string to a numeric
   */
  convertStrToNum(applicationId: any) {
    // Check if applicationId is neither null, undefined, nor the string "undefined"
    if (
      applicationId !== null &&
      applicationId !== undefined &&
      applicationId !== 'undefined'
    ) {
      this.getApiList(applicationId);
      this.form.searchParams['applicationId'] = Number(applicationId);
    } else {
      this.usecases = [];
    }
  }

  /**
   * Convert the value string to a numeric
   */
  convertStrToNumUser(userstoryId: any) {
    if (
      userstoryId !== null &&
      userstoryId !== undefined &&
      userstoryId !== 'undefined'
    ) {
      this.getFormList(userstoryId);
      this.getReport(userstoryId);
      this.form.searchParams['userstoryId'] = Number(userstoryId);
      this.form.searchParams['userstoryId'] = Number(userstoryId);
    } else {
      this.forms = [];
      this.reportlist = [];
      this.form.searchParams['formId'] = 'undefined';
      this.form.searchParams['reportsId'] = 'undefined';
    }
  }

  /**
   * Convert the value string to a numeric
   */
  convertStrToNumForm(formId: any) {
    if (formId !== null && formId !== undefined && formId !== 'undefined') {
      this.onFormChange(formId);
      this.form.searchParams['formId'] = Number(formId);
    }
  }
  /**
   * Convert the value string to a numeric
   */
  convertStrToNumReport(reportsId: any) {
    if (
      reportsId !== null &&
      reportsId !== undefined &&
      reportsId !== 'undefined'
    ) {
      this.getReport(reportsId);
      this.form.searchParams['reportsId'] = Number(reportsId);
    }
  }

  /**
   * Get the list of usecases
   */
  async getApiList(applicationId: any) {
    let _self = this;
    // get applications
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/usecases/' +
      applicationId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecases = res.result.data;
    });
  }

  /**
   * Get the form by Form Id
   */
  onFormChange(formId: any): void {
    let _self = this;
    let form: any = _self.forms.filter((e: any) => e['id'] == formId);
  }

  /**
   *
   * @param id
   * @param callback
   * @returns
   */
  async getReport(id: any, callback?: any) {
    let _self = this;
    if (!id || id == 0) {
      if (callback) {
        callback();
      }
      return;
    }

    let searchParams = {
      userstoryId: Number(id),
    };
    try {
      const property =
        await _self.locator.config.getProperty('endpoint.reports');
      const url = `${property}/search`;
      this.locator.http.post(
        url,
        searchParams,
        function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          // Handle the response
          if (res.success) {
            _self.reportlist = res.result.data;
          } else {
            _self.form.error = true;
            _self.form.message = res.result.message;
          }
          // Invoke the callback if provided
          if (callback) {
            callback();
          }
        },
      );
    } catch (error) {
      console.error('Error fetching report:', error);
    }
  }

  /**
   * switch main and archive
   * @param tab
   */
  toggleTab(tab: string): void {
    this.isProfileTabActive = tab === 'profile';
    this.searchArchived();
  }

  /**
   * searchArchived
   * @param callback
   */
  async searchArchived(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.application.menus')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.isConfirmDelete = true;
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }

        let url =
          this.locator.config.get('endpoint.application.menus') +
          '/retrieve/' +
          id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.message = 'Data is retrieved';
            _self.searchArchived();
            _self.search();
            if (callback) {
              callback(res, error);
            }
          }
        });
      }
    }
  }

  //----------------------Assign Usecase to Menu----------------------

  /**
   * Form contains preload data, error/sucess message
   */
  public appRoleform: any = {
    error: false,
    message: '',
    preload: null,
    inputerror: {},
    data: { id: 0 },
    //Attributes for list page
    searchError: false,
    searchParams: {},
    searchMessage: '',
    usecasedocs: [],
    usecasedocparams: {},
    list: [],
    pageNo: 0,
    pageNos: 0,
    pageCount: 0,
    pageSize: 50,
    pageNoList: [1],
    isConfirmDelete: true, // use to call delete  ask confirm box
  };

  /**
   * save
   */
  public async saveAppRole() {
    let _self = this;
    _self.locator.config.get('endpoint.application.role');
    this.getData(
      'endpoint.application.role',
      '/save',
      _self.appRoleform.data,
      function (data: any, error: boolean, res: any) {
        if (error) {
          _self.form.error = true;
          _self.form.inputerror = res.result.inputerror;
          return;
        }
        _self.form.error = false;
        _self.form.message = 'Data is saved';
        _self.getRolesList(_self.selectAppId);
      },
    );
  }

  /**
   * Get role list as selected application
   * @param appId
   */
  public async getRolesList(appId: any) {
    let _self = this;
    _self.selectAppId = appId;
    let searchParams = {
      applicationId: Number(appId),
    };
    this.getData(
      'endpoint.application.role',
      '/search',
      searchParams,
      function (data: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.appRoleList = data;
        _self.getRoleMenu(_self.selectRoleId);
      },
    );
  }

  /**
   * Get role assign and unassign menus
   * @param roleId
   */
  async getRoleMenu(roleId: any) {
    let _self = this;
    _self.assignMenuList = [];
    _self.unassignMenuList = [];
    _self.selectRoleId = roleId;

    if (roleId == 'undefined' || roleId == undefined) {
      _self.selectRoleId = 0;
      _self.selectedRoleName = null;
      _self.assignMenuList = null;
      _self.nodes = null;
      return;
    }

    if (!roleId) {
      _self.selectRoleId = 0;
      _self.selectedRoleName;
      return;
    }

    // Find the role with the given roleId
    const selectedRole: any = _self.appRoleList.find(
      (role: any) => role.id == roleId,
    );

    _self.selectedRoleName = selectedRole['name'];
    if (selectedRole['menus']) {
      _self.assignMenuList = selectedRole['menus'];

      if (_self.assignMenuList.length > 0) {
        // Filter unassigned menus once

        // const assignedMenuIds = _self.assignMenuList.map(
        //   (menu: any) => menu.id
        // );

        const assignedMenuIds = this.getAllMenuIds(_self.assignMenuList);
        _self.unassignMenuList = _self.form.list.filter(
          (menu: any) => !assignedMenuIds.includes(menu.id),
        );

        // _self.parentChildHierarchy = _self.buildMenuHierarchy(_self.assignMenuList);
        // console.log("_self.parentChildHierarchy----->", _self.parentChildHierarchy)

        _self.assignMenuList.forEach((menu: any) => {
          if (!menu.children) menu.children = [];
          if (menu.isExpanded === undefined) menu.isExpanded = true;
        });

        this.nodes = _self.assignMenuList;

        // this.nodes = _self.buildMenuHierarchy(_self.assignMenuList);
        // this.prepareDragDrop(this.nodes);
      } else {
        // If no menus are assigned, all menus are unassigned
        _self.unassignMenuList = _self.form.list;
        _self.parentChildHierarchy = null;
        _self.assignMenuList = null;
        _self.nodes = null;
      }
    } else {
      // If no menus are assigned, all menus are unassigned
      _self.unassignMenuList = _self.form.list;
      _self.parentChildHierarchy = null;
      _self.assignMenuList = null;
      _self.nodes = null;
    }
    _self.expandMenus(_self.parentChildHierarchy, true);
  }

  getAllMenuIds(menus: any): any {
    let ids: number[] = [];
    menus.forEach((menu: any) => {
      ids.push(menu.id);
      if (menu.children) {
        ids = ids.concat(this.getAllMenuIds(menu.children));
      }
    });
    return ids;
  }

  /**
   * Assign menu to role
   * @param menuId
   * @param roleId
   */
  async assignMenu(menu: any) {
    let _self = this;
    if (_self.selectRoleId > 0) {
      _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          if (e['menus']) {
            e['menus'].push(menu);
          } else {
            e['menus'] = [];
            e['menus'].push(menu);
          }
          _self.appRoleform.data = e;
          _self.saveAppRole();
        }
      });
    }
    _self.getRoleMenu(_self.selectRoleId);
    _self.expandMenus(_self.parentChildHierarchy, true);
    this.cdr.detectChanges();
  }

  /**
   * Unassign menu to role
   * @param menuId
   * @param roleId
   */
  async unassignMenu(menu: any) {
    let _self = this;
    if (_self.selectRoleId > 0) {
      if (menu?.children?.length > 0) {
        _self.form.searchError = true;
        _self.form.searchMessage =
          'Please remove sub menu before remove main menu';
        return;
      }
      await _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          // e.menus = e.menus.filter((f: any) => f.id != menu.id);
          e.menus = _self.removeMenuRecursively(e.menus, menu.id);
          _self.appRoleform.data = e;
          _self.saveAppRole();
        }
      });
      _self.getRoleMenu(_self.selectRoleId);
      // _self.expandMenus(_self.parentChildHierarchy, true);
      this.cdr.detectChanges();
    }
  }

  removeMenuRecursively(menuList: any[], menuId: number): any[] {
    return menuList
      .map((menu) => {
        if (menu.children && menu.children.length > 0) {
          menu.children = this.removeMenuRecursively(menu.children, menuId);
        }
        return menu;
      })
      .filter((menu) => menu.id !== menuId);
  }

  setSubMenu(parentId: number) {
    let _self = this;
    _self.form.list.forEach((e: any) => {
      if (e['id'] == parentId) {
        const parentData = e;
        _self.form.data['applicationId'] = parentData['applicationId'];
        _self.form.data['parentName'] = parentData['name'];
        _self.getApiList(parentData['applicationId']);
      }
    });
  }

  move(menu: any, move: string) {
    let ind = menu.index + 1;
    if ('up' == move) {
      ind = menu.index - 1;
    }
    let _self = this;
    _self.save();
  }

  public async setParent(menu: any, event: any, index: any) {
    let _self = this;
    let value: any = event.target.value;

    if (
      value != undefined &&
      value != 'undefined' &&
      value !== null &&
      !Number.isNaN(value)
    ) {
      menu['parent'] = Number(value);
    } else {
      menu['parent'] = undefined;
    }
    if (_self.selectRoleId > 0) {
      _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          if (e['menus']) {
            e['menus'].forEach((m: any) => {
              if (m.id == menu.id) {
                if (
                  value != undefined &&
                  value != 'undefined' &&
                  value !== null &&
                  !Number.isNaN(value)
                ) {
                  m['parent'] = Number(value);
                } else {
                  m['parent'] = undefined;
                }
                _self.appRoleform.data = e;
                this.getData(
                  'endpoint.application.role',
                  '/save',
                  _self.appRoleform.data,
                  function (data: any, error: boolean, res: any) {
                    if (error) {
                      _self.form.error = true;
                      _self.form.inputerror = res.result.inputerror;
                      return;
                    }
                    _self.form.error = false;
                    _self.form.message = 'Data is saved';
                  },
                );
              }
            });
          }
        }
      });
    }

    _self.getRoleMenu(_self.selectRoleId);
    _self.expandMenus(_self.parentChildHierarchy, true);
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.linkto = data.linkto || null;
    form.parent = data.parent;
    form.applicationName = data.applicationName;
    form.userstoryName = data.userstoryName;
    form.userstoryId = data.userstoryId;
    form.formTitle = data.formTitle;
    form.formId = data.formId;
    form.reportsId = data.reportsId;
    form.url = data.url;
    form.parentName = data.parentName;
    form.applicationId = data.applicationId;
    if (data.applicationId) {
      this.getApiList(data.applicationId);
    }
    if (data.userstoryId) {
      this.getFormList(data.userstoryId);
    }
    if (data.reportsId) {
      this.getReport(data.userstoryId);
    }
    if (data.formId) {
      this.onFormChange(data.formId);
    }
  }

  override resetForm(): void {
    super.resetForm();
    this.form.data['applicationId'] = this.appId;
    this.form.data['linkto'] = null;
  }

  override resetSearchForm() {
    super.resetSearchForm();
    this.form.searchParams['applicationId'] = this.appId;
    this.search();
  }

  expandAll() {
    let _self = this;
    let data: any[] = [];
    if (_self.selectRoleId > 0) {
      _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          data = e['menus'];
        }
      });
    }

    // _self.menuItemsMenu = _self.buildMenuHierarchy(data);
  }

  toggleAllMenus(menuState: any) {
    // Expand menus with children
    this.isChildClicked = !menuState;
    this.expandMenus(this.nodes, menuState);
    // this.expandMenus(this.reportMenu, menuState);
  }

  // Recursive function to expand menus with children
  expandMenus(menuList: any[], menuState: any): void {
    menuList?.forEach((menu: any) => {
      // If the menu has children, expand it
      if (menu.children && menu.children.length > 0) {
        menu.isExpanded = menuState;
        // Recursively expand its children
        this.expandMenus(menu.children, menuState);
      }
    });
  }

  searchDataFilter() {
    if (this.form.searchParams) {
      let searchdata = Object.fromEntries(
        Object.entries(this.form.searchParams).filter(
          ([_, value]) =>
            value != undefined &&
            value != 'undefined' &&
            value !== null &&
            !Number.isNaN(value) &&
            value !== '',
        ),
      );

      searchdata = Object.fromEntries(
        Object.entries(searchdata).map(([key, value]) => {
          // Check if the key is not 'linkto', then convert to numeric if applicable
          if (key !== 'linkto' && key != 'name') {
            const numericValue =
              typeof value === 'string' ||
              typeof value === 'boolean' ||
              typeof value === 'number'
                ? Number(value)
                : value;
            return [key, numericValue];
          }
          // If the key is 'linkto', keep the original value
          return [key, value];
        }),
      );
      this.form.searchParams = searchdata;
      // Call the search method
      this.search1();
    }
  }
  search1() {
    this.form.list = [];
    this.search();
  }
  private messageTimeout: any;

  showMessage(message: string, isError: boolean = false) {
    this.searchMessage = message;
    this.searchError = isError;
    // Clear previous timeout before setting a new one
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
    this.messageTimeout = setTimeout(() => {
      this.closeAlert();
    }, 3000);
  }

  deleteMenu(e: any) {
    var _self = this;
    const id = e.id;
    let roleList = [];
    let allAssignMenu: any[] = [];
    let applicationId = e.applicationId;
    let check = _self.form.list.filter((item: any) => id == item.parent);

    let searchParams = {
      applicationId: Number(applicationId),
    };

    // Check if the item is already a parent
    if (check?.length > 0) {
      _self.showMessage(
        'This item is already a parent and cannot be deleted.',
        true,
      );
      _self.cdr.detectChanges();
      return;
    } else {
      // Fetch roles and assign menus
      this.getData(
        'endpoint.application.role',
        '/search',
        searchParams,
        function (data: any, error: boolean) {
          if (error) {
            _self.form['searchError'] = true;
            _self.form['searchMessage'] = 'Server Error: ' + error;
            _self.cdr.detectChanges();
            return;
          }

          roleList = data;
          if (roleList.length > 0) {
            roleList.forEach((role: any) => {
              if (role.menus && role.menus.length > 0) {
                allAssignMenu = [...allAssignMenu, ...role.menus];
              }
            });

            // Check if the menu is present in the assigned menus
            let isPresent = allAssignMenu.filter((item: any) => id == item.id);

            if (isPresent.length > 0) {
              _self.showMessage(
                'This menu is already assigned, so it cannot be deleted.',
                true,
              );
              _self.cdr.detectChanges();
              return;
            } else {
              _self.delete(e.id);

              _self.form.list = _self.form.list.filter(
                (item: any) => item.id !== id,
              );

              // _self.showMessage('Menu deleted successfully.', false);
              _self.cdr.detectChanges();
            }
          } else {
            _self.delete(e.id);
            _self.showMessage('Menu deleted successfully.', false);
            _self.form.list = _self.form.list.filter(
              (item: any) => item.id !== id,
            );

            _self.cdr.detectChanges();
          }
        },
      );
    }
  }

  closeAlert() {
    this.searchMessage = '';
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.assignMenuList,
      event.previousIndex,
      event.currentIndex,
    );
    let _self = this;
    if (_self.selectRoleId > 0) {
      _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          e['menus'] = [];
          e['menus'] = [..._self.assignMenuList];
          _self.parentChildHierarchy = [];
          _self.appRoleform.data = e;
          _self.saveAppRole();
        }
      });
    }
    _self.getRoleMenu(_self.selectRoleId);
    _self.expandMenus(_self.parentChildHierarchy, true);
    this.cdr.detectChanges();
  }

  dropChild(event: CdkDragDrop<any[]>, parentMenu: any) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(
        parentMenu.children,
        event.previousIndex,
        event.currentIndex,
      );
      // let _self = this;
      // if (_self.selectRoleId > 0) {
      //   _self.appRoleList.forEach((e: any) => {
      //     if (e.id == _self.selectRoleId) {
      //       e['menus']=[];
      //         e['menus'] = [..._self.assignMenuList];

      //       _self.appRoleform.data = e;
      //       _self.saveAppRole();
      //     }
      //   });
      // }
      // _self.getRoleMenu( _self.selectRoleId);
      // _self.expandMenus(_self.parentChildHierarchy,true);
      this.cdr.detectChanges();
    }
  }

  dropParent(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.parentChildHierarchy,
      event.previousIndex,
      event.currentIndex,
    );
  }

  onDragStart(event: DragEvent, node: any, parent?: any) {
    event.stopPropagation();
    this.draggedItem = node;
    this.draggedParent = parent || null;
    event.dataTransfer?.setData('text/plain', JSON.stringify(node));
  }

  onDragOver(event: DragEvent, targetNode: any) {
    event.preventDefault();
  }

  // drag element
  onDrop(event: DragEvent, targetNode?: any) {
    event.preventDefault();
    event.stopPropagation();

    const draggedData = event.dataTransfer?.getData('text/plain');
    if (!draggedData) return;

    const draggedItem = JSON.parse(draggedData);
    if (draggedItem.id === targetNode?.id) return;

    const targetElement = event.currentTarget as HTMLElement;
    const rect = targetElement.getBoundingClientRect();
    const dropY = event.clientY;

    const threshold = 0.2;
    const topBoundary = rect.top + rect.height * threshold;
    const bottomBoundary = rect.bottom - rect.height * threshold;

    let dropPosition: 'before' | 'after' | 'inside' | undefined;

    if (dropY < topBoundary) {
      dropPosition = 'before';
    } else if (dropY > bottomBoundary) {
      dropPosition = 'after';
    } else if (dropY >= topBoundary && dropY <= bottomBoundary) {
      dropPosition = 'inside';
    } else {
      dropPosition = undefined;
    }

    if (!dropPosition) {
      console.warn('⚠ Invalid drop position. Ignoring drop.');
      return;
    }
    this.handleDrop(draggedItem, targetNode, dropPosition);
  }

  // Insert before , after , insde of target element
  handleDrop(
    draggedItem: any,
    targetNode: any,
    dropPosition: 'before' | 'after' | 'inside',
  ) {
    if (!draggedItem || !targetNode) return;

    if (this.isDescendant(draggedItem, targetNode)) {
      console.warn('⚠ Invalid drop! Cannot move a parent into its own child.');
      return;
    }

    // Step 1: Remove dragged item from its current position
    this.nodes = this.deleteItemById(this.nodes, draggedItem.id);

    // Step 2: Find target node's parent
    let parentNode = this.findParentNode(this.nodes, targetNode.id);

    // If the target is at root level, we handle it separately
    if (!parentNode) {
      parentNode = { children: this.nodes };
    }

    // Step 3: Insert dragged item based on drop position
    if (dropPosition === 'before' || dropPosition === 'after') {
      const targetIndex = parentNode.children.findIndex(
        (node: any) => node.id === targetNode.id,
      );
      if (targetIndex === -1) return;

      if (dropPosition === 'before') {
        parentNode.children.splice(targetIndex, 0, draggedItem); // Insert before
      } else if (dropPosition === 'after') {
        parentNode.children.splice(targetIndex + 1, 0, draggedItem); // Insert after
      }
    } else if (dropPosition === 'inside') {
      if (!targetNode.children) {
        targetNode.children = [];
      }
      targetNode.children.push(draggedItem);
    }

    // save data
    let _self = this;
    if (_self.selectRoleId > 0) {
      _self.appRoleList.forEach((e: any) => {
        if (e.id == _self.selectRoleId) {
          e['menus'] = [];
          e['menus'] = this.nodes;

          _self.appRoleform.data = e;
          _self.saveAppRole();
        }
      });
    }
    _self.getRoleMenu(_self.selectRoleId);
  }

  // find parent
  findParentNode(
    nodes: any[],
    targetNodeId: string,
    parentNode: any = null,
  ): any {
    for (const node of nodes) {
      if (node.id === targetNodeId) {
        return parentNode;
      }
      if (node.children) {
        const foundParent = this.findParentNode(
          node.children,
          targetNodeId,
          node,
        );
        if (foundParent) {
          return foundParent;
        }
      }
    }
    return null;
  }

  // delete from assign menu list
  deleteItemById(nodes: any[], itemId: number): any[] {
    return nodes
      .map((node) => {
        if (node.children) {
          node.children = this.deleteItemById(node.children, itemId);
        }
        return node;
      })
      .filter((node) => node.id !== itemId);
  }

  // check  drop element is child of target elemet
  isDescendant(parent: any, child: any): boolean {
    if (!parent.children) return false;
    for (const node of parent.children) {
      if (node.id === child.id || this.isDescendant(node, child)) {
        return true;
      }
    }
    return false;
  }

  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;

  sortTable(field: string): void {
    let _self = this;
    // Update sorting state
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    // Set sorting parameters
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;

    // Call search method
    this.search();
  }
}
